module.exports = __webpack_public_path__ + "img/head_logo.f10018ba.png";